import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { VERTICAL_EMBED_TYPE } from "../types.js";
import { VerticalEmbedViewer } from "./vertical-embed-viewer.js";
const VerticalEmbed = ({ node, nodeIndex, NodeViewContainer }) => {
  const { helpers, config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    VerticalEmbedViewer,
    {
      nodeId: node.id,
      settings: config[VERTICAL_EMBED_TYPE] || {},
      componentData: node.appEmbedData,
      helpers
    }
  ));
};
var vertical_embed_default = VerticalEmbed;
export {
  vertical_embed_default as default
};
//# sourceMappingURL=vertical-embed.js.map

import "@wix/ricos/css/plugin-vertical-embed-viewer.global.css";